import { render, staticRenderFns } from "./resetPasswordForm.vue?vue&type=template&id=1be877c2&"
import script from "./resetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./resetPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./resetPasswordForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "resetPasswordForm.vue"
export default component.exports